export default "__VITE_ASSET__w3Yq$Jq1__"